module.exports = __webpack_public_path__ + "img/singup10.1fa6ba06.jpg";